import React, { useEffect, useContext, useState } from 'react';
import axiosConfig from '../../utils/axiosConfig';
import { Link, NavLink } from 'react-router-dom';
import { masterNavItems, schoolAdminNavItems, subjectCoordinatorNavItems, facultyNavItems, studentNavItems } from '../../utils/menuItems';
import clsx from "clsx";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { deepOrange, deepPurple } from '@material-ui/core/colors';
import Skeleton from '@material-ui/lab/Skeleton';
import { Badge } from '@material-ui/core'
import NavigationItems from './Tabs/Mobile/NavigationItems';

import {
    Assignment as AssignmentIcon,
    AccountCircle as AccountCircleIcon,
    ChevronLeft as ChevronLeftIcon,
    DescriptionTwoTone as DescriptionTwoToneIcon,
    EventNoteTwoTone as EventNoteTwoToneIcon,
    ExitToApp as ExitToAppIcon,
    HomeTwoTone as HomeTwoToneIcon,
    Menu as MenuIcon,
    MoreVert as MoreIcon,
    SettingsTwoTone as SettingsTwoToneIcon,
    AirlineSeatReclineNormalOutlined,
    EmailIcon
} from "@material-ui/icons";

import {
    Avatar, AppBar, Box, CardMedia, CssBaseline, Divider, Drawer, Grid,
    Hidden, IconButton, List, ListItem, ListItemIcon, ListItemText,
    ListSubheader, LinearProgress, Link as MuiLink, Menu, MenuItem, Paper,
    Tab, Tabs, Typography, Toolbar, useMediaQuery,
} from "@material-ui/core";

import SerratedTabs from '../Layouts/Tabs/SerratedTabs/SerratedTabs';
import FacultySettingsDialog from '../Faculty/SettingsDialog/SettingsDialog';
import SnackbarPopup from '../../components/Shared/SnackbarPopup/SnackbarPopup';
import Messages from './Tabs/Messages/Messages'

import { StateContext, DispatchContext } from '../../context/Provider';

import './Layout.css'

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
    },
    appBar: {
        [theme.breakpoints.up("sm")]: {
            // transition: theme.transitions.create(["margin", "width"], {
            //     easing: theme.transitions.easing.sharp,
            //     duration: theme.transitions.duration.leavingScreen,
            // }),
            flexShrink: 0,
        },
    },
    appBarShift: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
        // transition: theme.transitions.create(["margin", "width"], {
        //     easing: theme.transitions.easing.easeOut,
        //     duration: theme.transitions.duration.enteringScreen,
        // }),
    },
    menuButton: {
        marginRight: theme.spacing(2),
    },
    hide: {
        display: "none",
    },
    drawer: {
        [theme.breakpoints.up("sm")]: {
            width: drawerWidth,
            flexShrink: 0,
        },
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: "flex",
        alignItems: "center",
        padding: theme.spacing(0, 1),
        // necessary for content to be below app bar
        ...theme.mixins.toolbar,
        justifyContent: "flex-end",
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(3),
        // transition: theme.transitions.create("margin", {
        //     easing: theme.transitions.easing.sharp,
        //     duration: theme.transitions.duration.leavingScreen,
        // }),
        [theme.breakpoints.up("sm")]: {
            marginLeft: -drawerWidth,
        },
    },

    contentShift: {
        // transition: theme.transitions.create("margin", {
        //     easing: theme.transitions.easing.easeOut,
        //     duration: theme.transitions.duration.enteringScreen,
        // }),
        marginLeft: 0,
    },

    appbarLogo: {
        width: '105px'
    },

    orange: {
        color: theme.palette.getContrastText(deepOrange[500]),
        backgroundColor: deepOrange[500],
        width: theme.spacing(4),
        height: theme.spacing(4),
    }

}));

const CustomTabs = withStyles({
    indicator: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
        '& > span': {
            maxWidth: 70,
            width: '100%',
            backgroundColor: '#EF6527',
        },
    }
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const CustomTab = withStyles((theme) => ({
    root: {
        textTransform: 'none',
        color: 'primary',
        // fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.pxToRem(14),
        marginRight: theme.spacing(1),
        '&:focus': {
            opacity: 1,
        },
    }
}))((props) => <Tab disableRipple {...props} />);

const ResponsiveDrawer = (props) => {

    const classcode = props.classcode;
    const appState = useContext(StateContext);
    const appDispatch = useContext(DispatchContext);

    const { authState, globalState } = appState;
    const { authDispatch, globalDispatch } = appDispatch;

    const classes = useStyles();
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [isMobileOpen, setIsMobileOpen] = useState(false);
    const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

    // For AppBar Menu
    const [anchorEl, setAnchorEl] = useState(null);
    const openDropdown = Boolean(anchorEl);

    const handleSmallScreenDrawerToggle = () => {
        setIsMobileOpen(!isMobileOpen);
    };

    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    // close drawer upon clicking navlink on mobile
    const handleDrawerCloseOnMobile = () => {
        if (isMobileOpen) {
            setIsMobileOpen(!isMobileOpen);
        }
    };

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    // const [navItems, setNavItems] = useState([]);

    useEffect(() => {
        authState.user.role_id == 1 && globalDispatch({type: "setSideMenuItems", value: masterNavItems});             // superadmin
        authState.user.role_id == 2 && globalDispatch({type: "setSideMenuItems", value: schoolAdminNavItems});        // school admin
        authState.user.role_id == 3 && globalDispatch({type: "setSideMenuItems", value: subjectCoordinatorNavItems}); // subject coordinator
        authState.user.role_id == 4 && globalDispatch({type: "setSideMenuItems", value: facultyNavItems});            // faculty
        authState.user.role_id == 5 && globalDispatch({type: "setSideMenuItems", value: studentNavItems});            // student

    }, []);

    const sideMenuItemsLength = globalState.sideMenuItems.length;

    const drawerItem = (
        <>
            <Divider />

            <CardMedia
                className={classes.media}
                image="/images/sidebar-bg.jpg"
                title="Contemplative Reptile"
                style={{'height': 180}}
            >
                <Box p={2}>
                    <Avatar alt="Profile Image" src={authState.user.avatar} style={{marginBottom: '5px'}} />

                    { authState.user.name ? (
                        <Typography paragraph style={{ fontWeight: 500, marginBottom: 0, color: '#fff' }}>
                            {authState.user.name}
                        </Typography>
                    ) : (<Skeleton animation={false} variant={'text'} />)}

                    { authState.user.name ? (
                        <Typography paragraph style={{ fontWeight: 'normal', fontSize: '12px', color: '#fff' }}>
                            {authState.user.role} <br />
                            {authState.user.school_name || null}
                        </Typography>
                    ) : (<Skeleton animation={false} variant={'text'} />)}
                </Box>
            </CardMedia>

            <div>
                {globalState.sideMenuItems.map((el, i) => (
                    <div key={i}>
                        <List
                            component="nav"
                            aria-labelledby="nested-list-subheader"
                            subheader={
                                el.subHeader ? (
                                    <ListSubheader component="div" id="nested-list-subheader">
                                        {el.subHeader}
                                    </ListSubheader>
                                ) : null
                            }
                        >
                            {el.subItems.map((subItem, index) => (
                                <ListItem
                                    key={index}
                                    component={NavLink}
                                    button
                                    to={subItem.url}
                                    activeClassName="Mui-selected"
                                    onClick={handleDrawerCloseOnMobile}
                                >
                                    <ListItemIcon>
                                        {subItem.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={<Typography variant="body1">
                                        {subItem.name}  {subItem.badge !== undefined && (
                                            <Badge style={{marginLeft: '20px'}} badgeContent={subItem.badge} color="primary" />
                                        )}
                                    </Typography> } />
                                </ListItem>
                            ))}
                        </List>
                        { sideMenuItemsLength === i + 1 ? null : <Divider />}
                    </div>
                ))}
            </div>

            {
                !authState.user.is_demo_account ? (
                    <Box
                        mt={5}
                        py={2}
                        style={{
                            position: "sticky",
                            bottom: 0,
                            backgroundColor: "#EBEBEB",
                        }}
                    >
                        <Typography align="center">
                            Powered by
                            <MuiLink href="https://academeportal.com" color="primary" target="_blank" underline="none">
                                &nbsp;Academe Portal
                            </MuiLink>
                        </Typography>
                    </Box>
                ) : null
            }

        </>
    );

    // tabs navbar for classrooms
    const [tabValue, setTabValue] = useState(0);
    const handleTabValueChange = (event, newTabValue) => {
        globalDispatch({type: 'setTabValue', value: newTabValue});
    };

    let serratedTabs = (<SerratedTabs classcode={classcode} />);
    if (!globalState.showTabs) {
        serratedTabs = null;
    }

    useEffect(() => {
        setOpen(!isSmallScreen);
    }, [isSmallScreen]);

    return (
        <div className={classes.root}>
            <CssBaseline />

            <AppBar
                position="fixed"
                // color="transparent"
                style={{backgroundColor: '#fff', color: '#000000'}}
                elevation={1}
                className={clsx(classes.appBar, {[classes.appBarShift]: open,})}
            >

                <Toolbar>
                    <IconButton
                        color="inherit"
                        aria-label="open drawer"
                        onClick={isSmallScreen ? handleSmallScreenDrawerToggle : handleDrawerOpen}
                        edge="start"
                        className={clsx(classes.menuButton, open && classes.hide)}
                    >
                        <MenuIcon />
                    </IconButton>

                    <div id="mobile-navigation">
                        <NavigationItems classcode={classcode} />
                    </div>

                    <div id="desktop-tabs">{serratedTabs}</div>

                    <div>
                        <Messages />
                    </div>

                    {/* <div>
                        <Notification />
                    </div> */}

                    <div>
                        <IconButton
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleMenu}
                            color="inherit"
                        >
                            <MoreIcon />
                        </IconButton>

                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorEl}
                            anchorOrigin={{
                                vertical: "top",
                                horizontal: "right"
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "right"
                            }}
                            open={anchorEl}
                            onClose={handleClose}
                        >
                            <MenuItem onClick={handleClose} component={Link} to="/my-account">
                                <AccountCircleIcon fontSize="small" style={{marginRight: '5px'}} />
                                My Account
                            </MenuItem>
                            <MenuItem onClick={handleClose} component={NavLink} to="/logout">
                                <ExitToAppIcon fontSize="small" style={{marginRight: '5px'}} />
                                Logout
                            </MenuItem>
                        </Menu>
                    </div>
                </Toolbar>

                { globalState.isLoading && (<LinearProgress color="primary" />) }
                { globalState.isOpenSnackbar && <SnackbarPopup isOpen={globalState.isOpenSnackbar} message={globalState.snackbarMsg} /> }

            </AppBar>
            <nav className={classes.drawer}>
                <Hidden smUp implementation="css">
                    <Drawer
                        variant="temporary"
                        anchor={theme.direction === "rtl" ? "right" : "left"}
                        open={isMobileOpen}
                        onClose={handleSmallScreenDrawerToggle}
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                    >
                        {drawerItem}
                    </Drawer>
                </Hidden>
                <Hidden xsDown implementation="css">
                    <Drawer
                        classes={{
                            paper: classes.drawerPaper,
                        }}
                        variant="persistent"
                        open={open}
                        transitionDuration={0}
                    >
                        <div className={classes.drawerHeader}>
                            <Grid container justify="center">

                                {
                                    !authState ? null :
                                    <>
                                        {
                                            authState.user.logo ? (
                                                <Box py={1} pb={0}>
                                                    <img
                                                        src={`${authState.user.logo || '/images/ap_epi_logo-resized.png'}`}
                                                        // src="/images/sjei-logo.jpg"
                                                        alt="logo"
                                                        className={classes.appbarLogo}
                                                        style={{
                                                            marginLeft: '35px',
                                                            height: '80px',
                                                            width: '80px'
                                                        }}
                                                    />
                                                </Box>

                                            ) : (
                                                <img
                                                    src="/images/ap_epi_logo-resized.png"
                                                    alt="logo"
                                                    className={classes.appbarLogo}
                                                    style={{marginLeft: '35px'}}
                                                />
                                            )
                                        }
                                    </>
                                }

                            </Grid>
                            <IconButton onClick={handleDrawerClose}>
                                <ChevronLeftIcon />
                            </IconButton>
                        </div>
                        <Divider />
                        {drawerItem}
                    </Drawer>
                </Hidden>
            </nav>
            <main className={clsx(classes.content, {[classes.contentShift]: open})}>
                <div className={classes.drawerHeader} />
                {props.children}
            </main>
        </div>
    );
}

export default ResponsiveDrawer;